export interface Accordion {
    title?: string,
    content?: string,
    closeOhters?: boolean,
    icon?: string,
}

export const accordion1: Accordion[] = [
    {
        title: "Integrating WordPress with Your Website?",
        content: "How you approach this process will depend on which web host you use. For example, a lot of hosting providers use cPanel, which includes an option to set up subdomains with just a few clicks.",
        icon: "file-text"
    },
    {
        title: "WordPress Site Maintenance ?",
        content: "We’ve just published a detailed on how to backup your WordPress website, however, if you’re in a hurry, here’s a quick solution.",
        icon: "file-text"
    },
    {
        title: "Meta Tags in WordPress ?",
        content: "Manually adding meta tags in WordPress is relatively simple. For this demo, we’ll use the example from the WordPress Codex. Imagine you’re Harriet Smith, a veterinarian who blogs about their animal stories on WordPress.",
        icon: "file-text"
    },
    {
        title: "WordPress in Your Language ?",
        content: "As of version 4.0, you can have WordPress automatically install the language of your choice during the installation process.",
        icon: "file-text"
    },
]

export const accordion2: Accordion[] = [
    {
        title: "WordPress Site Maintenance ?",
        content: "We’ve just published a detailed on how to backup your WordPress website, however, if you’re in a hurry, here’s a quick solution.",
        icon: "file-text"
    },
    {
        title: "WordPress in Your Language ?",
        content: "As of version 4.0, you can have WordPress automatically install the language of your choice during the installation process.",
        icon: "file-text"
    },
    {
        title: "Integrating WordPress with Your Website ?",
        content: "How you approach this process will depend on which web host you use. For example, a lot of hosting providers use cPanel, which includes an option to set up subdomains with just a few clicks.",
        icon: "file-text"
    },
]

export const accordion3: Accordion[] = [
    {
        title: "WordPress Site Maintenance ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "Meta Tags in WordPress ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "Integrate WordPress Website ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "WordPress Site Maintenance ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
]

export const accordion4: Accordion[] = [
    {
        title: "WordPress Site Maintenance ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "WordPress in Your Language ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "Integrate WordPress Website ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "WordPress Site Maintenance ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
    {
        title: "WordPress Site Maintenance ?",
        content: "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        icon: "file-text"
    },
]